import FingerprintJS from "@fingerprintjs/fingerprintjs";

const fpPromise = FingerprintJS.load();

export const generateUniqueId = async (): Promise<string> => {
  let tabId = sessionStorage.getItem("assessmentTabId");

  if (!tabId) {
    tabId = crypto.randomUUID();
    sessionStorage.setItem("assessmentTabId", tabId);
  }

  let visitorId = localStorage.getItem("assessmentVisitorId");

  if (!visitorId) {
    const fp = await fpPromise;
    const result = await fp.get();

    visitorId = result.visitorId;
    localStorage.setItem("assessmentVisitorId", visitorId);
  }

  return `${visitorId}-${tabId}`;
};
